import styled from 'styled-components'

export const UndoButtons = styled.button`
  width: 100%;
  height: 40px;
  background: #EFEFEF; 
  border-radius: 60px;
  transition: transform 0.2s, background-color 0.2s;
  color: #BEBEBE; 
  /* &:hover {
    transform: scale(1.1); 
    background-color: #007bff; 
    color: #fff;
  } */
`;
